import { _ } from 'wgnet-awesomejs';
import $ from 'jquery';
import Spinner from 'spin.js/spin.js';

import BaseInput from 'source/lib/component/input/base';
import messages from 'messages';

import template from './template.html';

const SPINNER = Symbol('spinner');

const CaptchaInput = BaseInput.extend({
    name: 'captcha-input',
    template,

    defaultSpinnerOptions: {
        lines: 11,
        length: 5,
        width: 2,
        radius: 5,
        corners: 1,
        rotate: 0,
        direction: 1,
        color: '#fff',
        speed: 1.1,
        trail: 60,
        shadow: false,
        hwaccel: false,
        className: 'spinner',
        zIndex: 2e9,
        top: '50%',
        left: '50%',
    },

    spinner() {
        this[SPINNER] = this[SPINNER] || new Spinner(this.spinnerOptions);
        return this[SPINNER];
    },

    initialize(options) {
        const parsedOptions = options;
        try {
            parsedOptions['pow-allowed'] = JSON.parse(parsedOptions['pow-allowed']);
        } catch (e) {
            parsedOptions['pow-allowed'] = false;
        }

        this.spinnerOptions = _.extend({}, this.defaultSpinnerOptions, options.spinnerOptions);

        this.isWaiting = false;
        BaseInput.prototype.initialize.call(this, parsedOptions);
        this.forcedMessage = this.data['pow-allowed'];
        this.$el.hide();
        this.bindElements();
        this.bindParent();
    },
    events: {
        'click .js-captcha-reload': 'reload',
        'change .js-captcha-input': 'change',
        'keyup .js-captcha-input': 'onClearErrors',
    },
    bindElements() {
        this.$image = this.$('.js-captcha-image');
        this.$reloadBtn = this.$('.js-captcha-reload');
        this.$input = this.$('.js-captcha-input');
        this.$error = this.$('.js-form-field-error-content');
        this.$spinnerContainer = this.$('.js-captcha-spinner-container');
    },
    bindParent(...args) {
        BaseInput.prototype.bindParent.apply(this, args);
        this.$root = $('#js-view');
        this.$root.on(
            'component:all:captcha:show',
            _.bind(this.updateChallenge, this),
        );
        this.$root.on(
            'component:all:captcha:hide',
            _.bind(this.hide, this),
        );
    },
    startWaiting() {
        if (this.isWaiting) {
            return;
        }
        this.isWaiting = true;

        this.$spinnerContainer.css('background', 'rgba(0, 0, 0, 0.5)');
        this.$reloadBtn.css('border-color', 'rgba(255, 255, 255, 0.2)');
        this.spinner().spin(this.$spinnerContainer[0]);
    },
    stopWaiting() {
        if (!this.isWaiting) {
            return;
        }
        this.isWaiting = false;

        this.spinner().stop();
        this.$spinnerContainer.css('background', 'transparent');
        this.$image.css('opacity', '1');
        this.$reloadBtn.css('border-color', 'rgba(255, 255, 255, 0.5)');
    },
    onParentError(event, origin) {
        const errors = _.extract(origin, 'responseJSON.errors.captcha');

        if (errors) {
            const key = errors[0] || 'required';
            const msg = _.extract(messages, `errors.captcha.${key}`)
                || _.extract(messages, 'errors.captcha.default', '');
            this.$error.html(msg);
            this.$error.removeClass('hidden');
            if (this.forcedMessage) {
                this.addErrorMessageClass();
            }
        } else {
            this.onClearErrors();
        }
    },
    onClearErrors() {
        this.$error.addClass('hidden');
        this.$error.html('');
        if (this.forcedMessage) {
            this.removeErrorMessageClass();
        }
    },
    onErrorUpdate() {
        this.value = undefined;
    },
    updateChallenge(event, data) {
        this.$el.show();
        this.startWaiting(); // The overlay with the spinner appears ON TOP of the old image

        const newUrl = data.url;

        // Create a real DOM element instead of a virtual Image object.
        // This ensures the browser keeps the downloaded pixels without re-requesting them.
        const newImg = document.createElement('img');
        newImg.className = 'js-captcha-image';

        $(newImg).on('load', () => {
            this.$image.remove();
            this.$spinnerContainer.before(newImg);
            this.$image = $(newImg);

            this.stopWaiting();
        });

        $(newImg).on('error', () => {
            this.stopWaiting();
        });

        // Trigger the single network request
        newImg.src = newUrl;
        this.$input.val('');
    },
    addErrorMessageClass() {
        this.$el.children('fieldset').addClass(this.data['error-class']);
    },
    removeErrorMessageClass() {
        this.$el.children('fieldset').removeClass(this.data['error-class']);
    },
    hide() {
        this.$el.hide();
        this.$image.removeAttr('src');
        this.stopWaiting();
    },
    reload(event) {
        this.startWaiting();
        this.components.proxyEvent('reload', event, this);
        return false;
    },
});

export default CaptchaInput;
